import { useEffect, useState } from "react";
import { _CompetitionType, _EmployeePayments, _Entailment, _MacroProcess, _single } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { SelectAccountantTree } from "../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { TaxHoldeditor } from "./EmployeePayments.editor";
import { EmployeePaymentsUnits } from "./EmployeePaymentsUnits.editor";
import { SelectBudgetID } from "../../../admin/configuracion/BudgetID/SelectBudgetID";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { PayrollFactorVdosSelect } from "../PayrollFactorVdos/PayrollFactorVdosSelect";
import { EmployeeBenefitEditor } from "../EmployeeBenefit/EmployeeBenefitEditor";




export const EmployeePayments = () => {

    const { instance, bean, setBean, lista, setLista, addRequiredFields, isMissing, isRequired, validateForm, handleChange } = useDataBean(_EmployeePayments);

    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();

    }, [])

    useEffect(() => {
        const requiredFields = ["Name", "Code", "Percent", "IDTaxHold", "BaseHours", "UnitsType", "IDPayrollFactor"];
        addRequiredFields(requiredFields);
    }, [])

    const getLista = () => {

        instance.getEmployeePaymentsTypeCatalog().then(
            (resp: any) => {
                if (resp) {
                    resp.forEach(element => {
                        const payment = element.DataBeanProperties;
                        payment.BenefitData = payment.IDEmployeeBenefit ? `${payment.EmployeeBenefitCode} - ${payment.EmployeeBenefitName}` : "N/P"
                    });
                    setLista(resp)
                }
            }
        ).catch(err => toast.error(err))

    }

    const create = () => {
        setBean({
            BaseHours: 240,
            WageFactor: false,
            ApplyBudget: false,
            DoTaxHold: false,
            ApplyRetroactive: false,
            DoLiquidate: false,
        });
        setModal({ ...modal, "name": "Agregar", "view": true });
    }

    const deleteItem = () => {
        instance.deleteEmployeePaymentsType(bean.IDEmploymentBonus).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }

    const editaItem = () => {
        if (!validateForm()) {
            toast.error("Faltan campos obligatorios por diligenciar");
            return;
        }

        instance.updateEmployeePaymentsType(bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDEmploymentBonus', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Mnemonico', property: 'Code', visible: true },
        { title: 'Factor de Configuración de Nómina', property: 'PayrollFactorName', visible: true },
        { title: 'Aplicar Retractivo', property: 'ApplyRetroactive', visible: true },
        { title: '%', property: 'Percent', visible: true, mask: MASK_NUMBER },
        { title: 'Factor Salarial', property: 'WageFactor', visible: true },
        { title: 'Factor de Retención', property: 'TaxHoldDescription', visible: true },
        { title: 'Horas Base', property: 'BaseHours', visible: true },
        { title: 'Unidades', property: 'UnitsTypeName', visible: true },
        { title: 'Incluir en Liquidación', property: 'DoLiquidate', visible: true },
        { title: 'Retefuente', property: 'DoTaxHold', visible: true },
        { title: 'Beneficio de Empleado', property: 'BenefitData', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Conceptos de Ingresos Laborales">
            <div className="row">
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${isMissing('Name') ? 'has-error' : ''}`}>Nombre {isRequired('Name') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" name="Name" className="form-control" value={bean.Name} onChange={handleChange} />

                            </div>
                            <div className="col-md-6">
                                <label className={`${isMissing('Code') ? 'has-error' : ''}`}>Mnemonico {isRequired('Code') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" name="Code" className="form-control" value={bean.Code} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${isMissing('Percent') ? 'has-error' : ''}`}>% {isRequired('Percent') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" name="Percent" className="form-control" value={bean.Percent} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${isMissing('IDPayrollFactor') ? 'has-error' : ''}`}>Factor de Configuración de Nómina {isRequired('IDPayrollFactor') ? <span className="text-danger">*</span> : ''}</label>
                                <PayrollFactorVdosSelect render={bean.PayrollFactorName} idSelector={bean.IDPayrollFactor} onChange={(e) => { setBean({ ...bean, "IDPayrollFactor": e.IDPayrollFactor, "PayrollFactorName": e.Name }) }} label=" " returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <label className={`${isMissing('IDEmployeeBenefit') ? 'has-error' : ''}`}>Beneficio de Empleado {isRequired('IDEmployeeBenefit') ? <span className="text-danger">*</span> : ''}</label>
                                <EmployeeBenefitEditor
                                    label=" "
                                    idSelector={bean.IDEmployeeBenefit}
                                    onChange={(e: any) => {
                                        setBean({
                                            ...bean,
                                            "IDEmployeeBenefit": e.IDEmployeeBenefit
                                        })
                                    }}
                                />
                            </div>
                            {/* <div className="col-md-6">
                                <label>Cuenta Débito</label>
                                <SelectAccountantTree label="Cuenta Contable" jsonCode={bean.AccountantID} onChange={(e) => { setBean({ ...bean, "AccountantID": e.JsonCode }) }} />
                            </div> */}
                            <div className="col-md-6">
                                <label>Factor Salarial</label>
                                <BasicSwitch label="Activo" estado={bean.WageFactor} eventChange={(e) => { setBean({ ...bean, "WageFactor": e }) }} />
                            </div>
                            <div className="col-6 d-flex align-items-center">
                                <BasicSwitch label="Aplicar Retractivo" estado={bean.ApplyRetroactive} eventChange={(e) => { setBean({ ...bean, "ApplyRetroactive": e }) }} />
                            </div>
                            {/* <div className="col-md-6">
                                <SelectBudgetID tipoPresupuesto={0} idBudgetID={bean.BudgetIDStr} edit={false} onChange={(e: any) => { setBean({ ...bean, "BudgetIDStr": e.IDLn }) }} />
                            </div> */}
                            <div className="col-md-6">
                                <label className={`${isMissing('IDTaxHold') ? 'has-error' : ''}`}>Factor de Retención {isRequired('IDTaxHold') ? <span className="text-danger">*</span> : ''}</label>
                                <TaxHoldeditor label=" " idSelector={bean.IDTaxHold} onChange={(e) => { setBean({ ...bean, "IDTaxHold": e }) }} />

                            </div>
                            {/* <div className="col-md-6">
                                <label>Cuenta Crédito</label>
                                <SelectAccountantTree label="Cuenta Contable" jsonCode={bean.CreditAccountantID} onChange={(e) => { setBean({ ...bean, "CreditAccountantID": e.JsonCode }) }} />
                            </div> */}
                            <div className="col-md-6">
                                <label className={`${isMissing('BaseHours') ? 'has-error' : ''}`}>Horas Base {isRequired('BaseHours') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" name="BaseHours" className="form-control" value={bean.BaseHours} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${isMissing('UnitsType') ? 'has-error' : ''}`}>Unidades {isRequired('UnitsType') ? <span className="text-danger">*</span> : ''}</label>
                                <EmployeePaymentsUnits label=" " idSelector={bean.UnitsType} onChange={(e) => { setBean({ ...bean, "UnitsType": e }) }} />

                            </div>
                            {/* <div className="col-md-6">
                                <label>Aplicar Presupuesto</label>
                                <BasicSwitch label="Activo" estado={bean.ApplyBudget} eventChange={(e) => { setBean({ ...bean, "ApplyBudget": e }) }} />

                            </div> */}
                            <div className="col-md-6">
                                <label>Retefuente</label>
                                <BasicSwitch label="Activo" estado={bean.DoTaxHold} eventChange={(e) => { setBean({ ...bean, "DoTaxHold": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Incluir en Liquidación" estado={bean.DoLiquidate} eventChange={(e) => { setBean({ ...bean, "DoLiquidate": e }) }} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}
